module.exports = __webpack_public_path__ + "static/media/homepage-manifesto.daf9f537.png";